export const taxRateTypes = {
    federal: 1,
    state: 2,
    difference: 3,
    effective: 4,
    average: 5,
    custom: 6
}